import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const areas = ['Henderson, NV', 'Las Vegas, NV', 'Green Valley', 'Summerlin', 'Boulder City', 'North Las Vegas'];
export function ServiceArea() {
  return <section className="py-20 bg-white border-t border-gray-100" data-id="element-262">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-264">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-265">
            <div className="flex items-center gap-2 text-brand-red font-bold tracking-widest uppercase text-sm mb-4" data-id="element-266">
              <MapPin className="w-5 h-5" data-id="element-267" />
              <span data-id="element-268">Local & Reliable</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-navy uppercase mb-6 leading-tight" data-id="element-269">
              Proudly Serving Henderson &amp; the Las Vegas Valley for 34 Years
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-270">
              We are a locally owned and operated business based in Henderson,
              NV. Our fleet of fully-stocked service vehicles is strategically
              stationed to provide fast, reliable service to homes and
              businesses across the Las Vegas Valley.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-271">
              {areas.map((area, index) => <div key={index} className="flex items-center gap-3" data-id="element-272">
                  <CheckCircle2 className="w-5 h-5 text-brand-red shrink-0" data-id="element-273" />
                  <span className="font-medium text-gray-800" data-id="element-274">{area}</span>
                </div>)}
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-275">
            <div className="relative rounded-md overflow-hidden shadow-2xl" data-id="element-276">
              <div className="absolute inset-0 bg-brand-navy/20 mix-blend-multiply z-10" data-id="element-277"></div>
              <img src="https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?q=80&w=2070&auto=format&fit=crop" alt="Industrial plumbing pipes installation" className="w-full h-[500px] object-cover" data-id="element-278" />
              {/* Decorative Badge */}
              <div className="absolute bottom-6 left-6 z-20 bg-white p-4 rounded-md shadow-lg flex items-center gap-4" data-id="element-279">
                <div className="bg-brand-red text-white p-3 rounded-md" data-id="element-280">
                  <MapPin className="w-6 h-6" data-id="element-281" />
                </div>
                <div data-id="element-282">
                  <p className="font-display font-bold text-brand-navy uppercase text-xl leading-none" data-id="element-283">
                    Fast Dispatch
                  </p>
                  <p className="text-sm text-gray-600 font-medium" data-id="element-284">
                    To all service areas
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}